import React from "react";
import * as Styles from "./style";
import * as Images from "../../../../images";
import * as Comp from "../../../../Components/Form";
import * as valdiation from "./validation";
import { POST_REQUEST } from "../../../../HooksApi/useApi";
import { USeInsertData } from "../../../../HookAxios/postData";
//icons
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import MailIcon from "@mui/icons-material/Mail";
import { Form, Formik } from "formik";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useIntl } from "react-intl";
import { CircularProgress, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
import TelegramIcon from "../../../../images/telgram.png";
import { width } from "@mui/system";

const ContactUs = () => {
  const intl = useIntl();
  const [phone, setPhone] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [Status, setStatus] = React.useState(false);
  const onSubmit = (data, { resetForm }) => {
    setStatus(true);
    contactUs({
      ...data,
      phone_number: phone,
      country_code: country,
    });
    setTimeout(() => {
      resetForm();
    }, 1000);
  };
  const {
    mutate: contactUs,
    status: contactUsStatus,
    data: contactUsData,
    error: contactUserror,
  } = POST_REQUEST({
    request: (data) => USeInsertData("contact_us", data),
    handelOnSettledError,
    handelOnSettledData,
  });
  function handelOnSettledError(error) {
    setStatus(false);
  }
  function handelOnSettledData(data) {
    setStatus(false);
  }
  const getPhone = (data, country) => {
    setPhone(data);
    setCountry(`00${country}`);
  };

  return (
    <Styles.Section>
      <Styles.HeadText>تواصل معنا</Styles.HeadText>
      <Styles.ContactBox>
        <Styles.ContactInformation>
          <Styles.ContactText>
            في حال لديك أسئلة أو استفسارات تواصل معنا
          </Styles.ContactText>
          <span
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "30px",
              marginTop: "30px",
            }}
          >
            <Styles.ContactText>
              <Styles.ContactLink>
                <PhoneInTalkIcon Style={{ color: "#fff" }} />
                <a href="tel:+963935839150" style={{ textDecoration: "none" }}>
                  <Styles.ContactText
                    style={{ fontSize: "14px", lineHeight: "0px" }}
                  >
                    <span dir="ltr"> +963 935 350 450</span>
                  </Styles.ContactText>
                </a>
              </Styles.ContactLink>
            </Styles.ContactText>
            <Styles.ContactText>
              <Styles.ContactLink>
                <MailIcon Style={{ color: "#fff" }} />
                <a
                  href="mailto:info@taleb.io"
                  style={{ textDecoration: "none" }}
                >
                  <Styles.ContactText
                    style={{ fontSize: "14px", lineHeight: "0px" }}
                  >
                    info@taleb.io
                  </Styles.ContactText>
                </a>
              </Styles.ContactLink>
            </Styles.ContactText>
          </span>
          <Styles.ContactLinkBox>
            <Styles.ContactTextTel style={{ textAlign: "center" }}>
              {" "}
              انتظرونا قريبا على Apple Store
            </Styles.ContactTextTel>
            <Styles.ContactTextImg>
              <Styles.ImgDown src={Images.AppStore} alt="" />

              <Styles.ImgDown
                src={Images.GooglePlay}
                alt=""
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.location.assign(
                    "https://play.google.com/store/apps/details?id=com.perla.taleb"
                  )
                }
              />
            </Styles.ContactTextImg>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                marginTop: "-12px",
              }}
            >
              <a
                href="https://shorturl.at/oDSW4"
                target="_blank"
                style={{ display: "flex", color: "#fff" }}
              >
                <Styles.ContactText
                  style={{
                    fontSize: "13px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: "0",
                  }}
                >
                  يمكنك تحميل تطبيق الاندرويد بشكل مباشر من هذا الرابط
                </Styles.ContactText>
                <CloudDownloadIcon style={{ color: "#fff", scale: "0.8" }} />
              </a>
            </div>
          </Styles.ContactLinkBox>
          <Styles.ContactImg>
            <a
              href="https://www.linkedin.com/company/talebonline/"
              target="_blank"
            >
              <Styles.Img src={Images.lindedIn} />
            </a>
            <a href="https://www.youtube.com/@Taleb.Online1" target="_blank">
              <Styles.Img src={Images.YoutYou} />
            </a>
            <a href="https://www.facebook.com/taleb.online1" target="_blank">
              <Styles.Img src={Images.faceBook} />
            </a>
            <a href="https://www.instagram.com/taleb.online1" target="_blank">
              <Styles.Img src={Images.instagrm} />
            </a>
            <a href="https://t.me/talebonline1" target="_blank">
              <Styles.Img src={TelegramIcon} />
            </a>
          </Styles.ContactImg>
        </Styles.ContactInformation>
        <Formik
          style={{ width: "45%" }}
          initialValues={valdiation.formikProps.initialValues}
          validationSchema={valdiation.formikProps.validationSchema}
          onSubmit={onSubmit}
          render={({ handleChange, handleBlur, values, errors, touched }) => (
            <Form style={{ width: "100%" }}>
              <Styles.ContactForm>
                <Styles.FormContact>
                  <h4
                    style={{
                      fontWight: "500",
                      fontSize: "16px",
                      margin: " 7px 0",
                    }}
                  >
                    الاسم الكامل
                  </h4>
                  <Comp.InputFail
                    width="100%"
                    placeholder="اكتب الاسم هنا"
                    border="none"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.full_name}
                    error={errors.full_name && touched.full_name}
                    errorText={
                      errors.full_name && touched.full_name
                        ? errors.full_name
                        : null
                    }
                    name="full_name"
                    style={{ borderBottom: "1px solid  #8D8D8D " }}
                  />
                </Styles.FormContact>
                <Styles.FormContact>
                  <h4
                    style={{
                      fontWight: "500",
                      fontSize: "16px",
                      margin: " 5px 0",
                    }}
                  >
                    موضوع الرسالة
                  </h4>
                  <Comp.DropDown
                    width="100%"
                    placeholder="اكتب الاسم هنا"
                    border="none"
                    style={{ borderBottom: "1px solid  #8D8D8D " }}
                    name="reason"
                    borederradius="0"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.reason}
                    error={errors.reason && touched.reason}
                    errorText={
                      errors.reason && touched.reason ? errors.reason : null
                    }
                  >
                    <MenuItem
                      disabled
                      style={{
                        fontWeight: "300px",
                        fontSize: "12px",
                        color: "gray",
                      }}
                      value="0"
                    >
                      اختر موضوع رسالتك
                    </MenuItem>
                    <MenuItem value="استفسار عن الاشتراك">
                      استفسار عن الاشتراك
                    </MenuItem>
                    <MenuItem value="استفسار عن الاسعار">
                      استفسار عن الاسعار
                    </MenuItem>
                    <MenuItem value="استفسار عن مشكلة تقنية">
                      استفسار عن مشكلة تقنية
                    </MenuItem>
                    <MenuItem value="موضوع آخر">موضوع آخر</MenuItem>
                  </Comp.DropDown>
                </Styles.FormContact>
                <Styles.FormContact>
                  <h4
                    style={{
                      fontWight: "500",
                      fontSize: "16px",
                      margin: " 2px 0 10px",
                      paddingBottom: "5px",
                    }}
                  >
                    رقم الهاتف المحمول
                  </h4>
                  <Comp.PhoneNumInput
                    onBlur={handleBlur}
                    inputProps={{ name: "phone_number" }}
                    onChange={(phoneNumber, country, e) => [
                      handleChange(e),
                      getPhone(
                        Number(
                          phoneNumber.slice(country.dialCode.length)
                        ).toString(),
                        country.dialCode
                      ),
                    ]}
                    error={errors.phone_number && touched.phone_number}
                    errorText={
                      errors.phone_number && touched.phone_number
                        ? errors.phone_number
                        : null
                    }
                    name="phone_number"
                    width="100%"
                    height="40px"
                    placeholder={intl.formatMessage({
                      id: `AuthSignUp.Placeholderphone`,
                    })}
                  />
                </Styles.FormContact>
                <Styles.FormContact>
                  <h4
                    style={{
                      fontWight: "500",
                      fontSize: "16px",
                      margin: " 5px 0",
                    }}
                  >
                    البريد الإلكتروني
                  </h4>
                  <Comp.InputFail
                    width="100%"
                    placeholder="اكتب البريد الالكتروني هنا"
                    border="none"
                    style={{ borderBottom: "1px solid  #8D8D8D " }}
                    type="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    error={errors.email && touched.email}
                    errorText={
                      errors.email && touched.email ? errors.email : null
                    }
                    name="email"
                  />
                </Styles.FormContact>
                <Styles.FormContactMulti>
                  <h4
                    style={{
                      fontWight: "500",
                      fontSize: "16px",
                      margin: " 5px 0",
                    }}
                  >
                    الرسالة
                  </h4>
                  <Comp.InputFail
                    height="100px"
                    minRows="3"
                    width="100%"
                    placeholder=" اكتب رسالتك هنا"
                    border="none"
                    multiline={true}
                    style={{
                      borderBottom: "1px solid  #8D8D8D ",
                      marginTop: "8px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.message}
                    error={errors.message && touched.message}
                    errorText={
                      errors.message && touched.message ? errors.message : null
                    }
                    name="message"
                  />
                </Styles.FormContactMulti>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    width: "100%",
                  }}
                >
                  {!Status ? (
                    <Styles.FormButooon>
                      <Comp.MuiButton
                        text="إرسال"
                        width="100%"
                        color="#fff"
                        background="#0056D2"
                      />
                    </Styles.FormButooon>
                  ) : (
                    <CircularProgress sx={{ alignSelf: "center" }} />
                  )}
                </div>
              </Styles.ContactForm>
            </Form>
          )}
        />
      </Styles.ContactBox>
    </Styles.Section>
  );
};

export default ContactUs;
